import { createRoot, hydrateRoot } from 'react-dom/client';
import { installChunkLoadReload } from '@bookkeeper/shared/chunk-reload';
import { captureFirstTouchUtms } from '@bookkeeper/shared/first-touch-utm';
import { initPostHog } from '@/lib/posthog';
import { captureExternalReferrer } from '@/lib/referrer';
import { installSignupHandoff } from '@/lib/signup-handoff';
import { initSentry } from '@/lib/sentry';
import App from './App.tsx';
import './index.css';

// Initialize observability on app load (browser only; the build-time prerender
// in src/entry-server.tsx renders App without these).
initSentry();
captureFirstTouchUtms();
captureExternalReferrer();
initPostHog();
installSignupHandoff();
// A tab opened before a deploy fails on a chunk the new build dropped (vite:preloadError): reload once.
installChunkLoadReload();

const container = document.getElementById('root')!;

// The build prerenders each route into its HTML entry and stamps the path it
// rendered (scripts/prerender.mjs). Hydrate only that exact route; any other
// URL served from the same file (index.html also serves /privacy and /terms)
// had its prerendered markup cleared by the inline guard and renders fresh.
if (container.dataset.prerenderedPath === window.location.pathname && container.firstElementChild) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
